<script setup lang="ts">

</script>

<template>
<v-footer>
  <v-container style="max-width: 1200px">
    <v-row justify="center" no-gutters>
      <v-col cols="12" class="d-flex justify-center gap-4 mb-2">
        <a href="https://about.clicjar.com/privacy">Privacy policy</a>
        <a href="https://about.clicjar.com/terms">Terms and conditions</a>
      </v-col>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>Clicjar</strong>
      </v-col>
    </v-row>
  </v-container>
</v-footer>
</template>

<style scoped>

</style>